import { BcRecurringModel } from '@bayclubs/recurring';
import { utils } from '@bayclubs/ui-core';

import { BlockedSlotSaveInputModel } from './blocked-slot-save-input.model';

export class BlockedSlotSaveFormModel {
    clubId: string;
    date?: utils.BcDate;
    timeFromInMinutes?: number;
    timeToInMinutes?: number;
    courtId?: string;
    note: string;
    recurring: BcRecurringModel;
    typeCode: string;

    public static init(input: BlockedSlotSaveInputModel): BlockedSlotSaveFormModel {
        const result = new BlockedSlotSaveFormModel();
        result.clubId = input.clubId;
        result.courtId = input.courtId;
        result.date = input.date;
        result.timeFromInMinutes = input.timeFrom != null ? input.timeFrom : 660;
        result.timeToInMinutes = input.timeTo != null ? input.timeTo : 720;
        return result;
    }
}
